import { FeeTypeEnum } from 'models/PropertyFees';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from 'utils/localeUtils';

const TypeCell = ({ getValue }: { getValue: () => FeeTypeEnum }) => {
  const { t } = useTranslation();
  const value = getValue();

  return (
    <span>
      {t(
        normalizeKey(
          `pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.types.${value}`,
        ),
      )}
    </span>
  );
};

export default TypeCell;
